import { StoreSeller } from '../../models';
import { Spinner } from '../../components/ui/Spinner';
import { EmptyState } from '../../components/ui/EmptyState';

interface SellerStepProps {
  sellers: StoreSeller[];
  loading: boolean;
  selectedSeller: StoreSeller | null;
  onSelect: (seller: StoreSeller) => void;
}

export function SellerStep({ sellers, loading, selectedSeller, onSelect }: SellerStepProps) {
  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner size="lg" />
      </div>
    );
  }

  if (sellers.length === 0) {
    return <EmptyState title="Nenhuma vendedora disponível no momento." />;
  }

  return (
    <div>
      <p className="text-text-light text-sm mb-4">
        Escolha uma vendedora. Ela irá cuidar da cobrança e entrega do seu pedido.
      </p>
      <div className="flex flex-col gap-3">
        {sellers.map((seller) => (
          <button
            key={seller.id}
            onClick={() => onSelect(seller)}
            className={[
              'w-full text-left bg-white rounded-xl p-4 shadow-sm flex items-center justify-between gap-4 border-2 transition-all',
              selectedSeller?.id === seller.id
                ? 'border-chocolate'
                : 'border-transparent hover:border-champagne-dark',
            ].join(' ')}
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-champagne flex items-center justify-center text-chocolate font-bold text-lg flex-shrink-0">
                {seller.name.charAt(0).toUpperCase()}
              </div>
              <div>
                <p className="font-medium text-text-dark">{seller.name}</p>
                <p className="text-xs text-text-light">{seller.whatsAppPhone}</p>
              </div>
            </div>
            <span className="text-xs font-medium text-chocolate border border-chocolate rounded-full px-3 py-1 whitespace-nowrap">
              Selecionar
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
